module.exports = __webpack_public_path__ + "static/media/caution2.25b47042.png";